import { bootstrapApplication } from '@angular/platform-browser';
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider, CustomProvider } from 'firebase/app-check';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// ── App Check debug token must be set BEFORE initializeAppCheck ───────────
if (!environment.production &&
    environment.appCheckDebugToken &&
    environment.appCheckDebugToken !== 'REPLACE_WITH_DEBUG_TOKEN') {
  (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = environment.appCheckDebugToken;
}

// ── Initialize Firebase + App Check synchronously before bootstrap ────────
// provideFirebaseApp() in app.config.ts will detect this existing app and reuse it.
const firebaseApp = initializeApp(environment.firebaseConfig);

const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

initializeAppCheck(firebaseApp, {
  provider: !isLocalhost && environment.recaptchaSiteKey
    ? new ReCaptchaEnterpriseProvider(environment.recaptchaSiteKey)
    : new CustomProvider({
        getToken: () => Promise.reject(new Error('Dev: App Check debug token active')),
      }),
  isTokenAutoRefreshEnabled: true,
});

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
